jQuery(document).ready(function ($) {
  //---- User Register Form -----------------------------------------------
  if ($("#UserRegisterForm").length) {
    console.log("UserRegisterForm");

    const contactForm = $("#UserRegisterForm");
    const submitButton = $("#form-submit");
    const loaderElement = $("#loader-form");
    const responseSuccessElement = $("#responseSuccess");

    $("#form-next-step").on("click", function (e) {
      e.preventDefault();

      const email = $("#email").val().trim();

      const emailPattern = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
      if (!emailPattern.test(email)) {
        $("#responseMessageEmail").html(
          '<div class="error" tabindex="0">Voer een geldig e-mailadres in.</div>'
        );
        return;
      }

      loaderElement.addClass("active");

      // Check if email is already registered
      $.ajax({
        url: "/api/form/user_register/check-email",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify({ email }),
        success: function (res) {
          console.log("res", res);
          $("#responseMessageEmail").html("");
          loaderElement.removeClass("active");
          $(".register-second").removeClass("hidden");
          $(".register-first").addClass("hidden");
        },
        error: function (e) {
          console.error("error", e);

          // Parse the error response as JSON
          const errorResponse = JSON.parse(e.responseText);

          try {
            errorResponse = JSON.parse(e.responseText);
            console.log("Parsed error response", errorResponse);
          } catch (err) {
            $("#responseMessageEmail").html(
              '<div class="error" tabindex="0">' + "email exist" + "</div>"
            );
          }

          responseSuccessElement
            .attr("tabindex", "-1")
            .attr("role", "alert")
            .removeClass("force-focus");

          if (errorResponse.errors.email) {
            $("#responseMessageEmail").html(
              '<div class="error" tabindex="0">' +
                errorResponse.errors.email[0] +
                "</div>"
            );
            responseSuccessElement.html(
              '<div class="error" tabindex="0">Niet alle velden zijn juist ingevuld</div>'
            );
          } else {
            $("#responseMessageEmail").html("");
          }

          setTimeout(function () {
            // Focus on the first error message
            let firstError = document.querySelector(".error");
            if (firstError) {
              firstError.focus();
              firstError.classList.add("force-focus");
              console.log("Focusing on the first error:", firstError);
            } else {
              console.log("No error to focus on");
            }
          }, 100); // Delay to allow DOM to update
          loaderElement.removeClass("active");
        },
      });
    });

    submitButton.on("click", function (event) {
      event.preventDefault();

      console.log("submitButton click");

      loaderElement.addClass("active");

      const formData = new FormData(contactForm[0]);
      const formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      $.ajax({
        url: "/api/form/user_register/submit",
        type: "POST",
        data: JSON.stringify(formValues),
        contentType: "application/json",
        success: function (response) {
          console.log("response", response);
          $("#responseMessageEmail").html("");
          responseSuccessElement.html("");

          loaderElement.removeClass("active");
          contactForm[0].reset();

          $(".register-second").addClass("hidden");
          $(".register-third").removeClass("hidden");
        },
        error: function (error) {
          console.error("error", error);
          try {
            const response = JSON.parse(error.responseText);
            console.log("Parsed error response", response);
          } catch (e) {
            console.log("Error parsing responseText", error.responseText);
          }

          loaderElement.removeClass("active");
        },
      });

      console.log("formValues", formValues);
    });
  }
});
